import React, { Component } from "react";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Normal user
const HomePage = React.lazy(() => import("./views/forestage/HomePage"));
const StoreMap = React.lazy(() => import("./views/forestage/StoreMap"));
const StoreList = React.lazy(() => import("./views/forestage/StoreList"));
const Promotions = React.lazy(() => import("./views/forestage/Promotions"));
const QrcodeScanner = React.lazy(() => import("./views/forestage/QRCodeScanner"));
const Reservation = React.lazy(() => import("./views/forestage/Reservation"));
const StoreIntro = React.lazy(() => import("./views/forestage/StoreIntro"));

const Login = React.lazy(() => import("./views/pages/login/LoginPage"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

// Store/BNB admin
// const Stats = React.lazy(() => import("./views/backstage/Stats"));
const StorePromotionList = React.lazy(() => import("./views/backstage/StorePromotionList"));
const StoreProfile = React.lazy(() => import("./views/backstage/StoreProfile"));
const Profile = React.lazy(() => import("./views/backstage/Profile"));
const EditProfilePage = React.lazy(() => import("./views/backstage/EditProfilePage"));

// admin
const AdminLogin = React.lazy(() => import("./views/admin/login/login"));
const AdminMain = React.lazy(() =>
  import("./views/admin/main/mainpage/MainPage")
);
const AdminQrCodeList = React.lazy(() =>
  import("./views/admin/main/system/QrCodeList")
);
const AdminCouponStatusList = React.lazy(() =>
  import("./views/admin/main/system/CouponStatus")
);

const AdminAccountList = React.lazy(() =>
  import("./views/admin/main/user/UserList")
);
const AdminStoreAdd = React.lazy(() =>
  import("./views/admin/main/store/StoreAdd")
);
const AdminStoreList = React.lazy(() =>
  import("./views/admin/main/store/StoreList")
);
const AdminLineAdd = React.lazy(() =>
  import("./views/admin/main/line/LineAdd")
);
const AdminLineList = React.lazy(() =>
  import("./views/admin/main/line/LineList")
);
const AdminPromotionAdd = React.lazy(() =>
  import("./views/admin/main/promotion/PromotionAdd")
);
const AdminPromotionList = React.lazy(() =>
  import("./views/admin/main/promotion/PromotionList")
);
const AdminReservationList = React.lazy(() =>
  import("./views/admin/main/reservation/ReservationList")
);
const AdminBnbList = React.lazy(() =>
  import("./views/admin/main/store/BnbList")
);

class App extends Component {
  render() {
    return (
      <HashRouter forceRefresh={true}>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
          
            <Route
              path="/map"
              name="StoreMap"
              render={(props) => <StoreMap {...props} />}
            />
            <Route
              path="/store"
              name="StoreList"
              render={(props) => <StoreList {...props} />}
            />
            <Route
              path="/promotions/:popup_id"
              name="Promotions_"
              render={(props) => <Promotions {...props} />}
            />
            <Route
              path="/promotions"
              name="Promotions"
              render={(props) => <Promotions {...props} />}
            />
            <Route
              path="/reservation/:promotion_id"
              name="Reservation"
              render={(props) => <Reservation {...props} />}
            />
            <Route
              path="/qrcode_scanner"
              name="QrcodeScanner"
              render={(props) => <QrcodeScanner {...props} />}
            />
            <Route
              path="/store_intro/:id"
              name="store_intro"
              render={(props) => <StoreIntro {...props} />}
            />


            <Route
              path="/admin/store_promotion_list"
              name="store_promotion_list"
              render={(props) => <StorePromotionList {...props} />}
            />
            <Route
              path="/admin/store_profile"
              name="sotre_profile"
              render={(props) => <StoreProfile {...props} />}
            />

            
            <Route
              path="/admin/profile"
              name="profile"
              render={(props) => <Profile {...props} />}
            />
            <Route
              path="/admin/edit_profile"
              name="edit_profile"
              render={(props) => <EditProfilePage {...props} />}
            />
            {/* <Route
              path="/admin/stats"
              name="stats"
              render={(props) => <Stats {...props} />}
            />     */}
            <Route
              path="/admin/login"
              name="AdminLogin"
              render={(props) => <AdminLogin {...props} />}
            />
            <Route
              path="/admin/main"
              name="AdminMain"
              render={(props) => <AdminMain {...props} />}
            />
            <Route
              path="/admin/system/qrcode_state"
              name="AdminQrCodeList"
              render={(props) => <AdminQrCodeList {...props} />}
            />
            <Route
              path="/admin/system/coupon_state"
              name="CouponStatus"
              render={(props) => <AdminCouponStatusList {...props} />}
            />

            <Route
              path="/admin/account/list"
              name="AdminUserList"
              render={(props) => <AdminAccountList {...props} />}
            />
            <Route
              path="/admin/promotion/adds"
              name="AdminPromotionAdd"
              render={(props) => <AdminPromotionAdd {...props} />}
            />
            <Route
              path="/admin/promotion/list"
              name="AdminPromotionList"
              render={(props) => <AdminPromotionList {...props} />}
            />
            <Route
              path="/admin/store/adds"
              name="AdminStoreAdd"
              render={(props) => <AdminStoreAdd {...props} />}
            />
            <Route
              path="/admin/store/list"
              name="AdminStoreList"
              render={(props) => <AdminStoreList {...props} />}
            />
            <Route
              path="/admin/line/adds"
              name="AdminLineAdd"
              render={(props) => <AdminLineAdd {...props} />}
            />
            <Route
              path="/admin/line/list"
              name="AdminLineList"
              render={(props) => <AdminLineList {...props} />}
            />
            <Route
              path="/admin/reservation/list"
              name="AdminReservationList"
              render={(props) => <AdminReservationList {...props} />}
            />
            <Route
              path="/admin/bnb/list"
              name="AdminReservationList"
              render={(props) => <AdminBnbList {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <HomePage {...props} />}
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
